"use strict";
/*
 * Copyright (C) 2024 Klaus Reimer <k@ailis.de>
 * See LICENSE.md for licensing information.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.isGroup = exports.isImageLayer = exports.isObjectGroup = exports.isUnencodedTileLayer = exports.isEncodedTileLayer = exports.isTileLayer = void 0;
const Encoding_1 = require("./Encoding");
/**
 * Checks if given layer is a tile layer.
 *
 * @param layer - The layer to check.
 * @returns True if layer is a tile layer, false if not.
 */
function isTileLayer(layer) {
    return layer.type === "tilelayer";
}
exports.isTileLayer = isTileLayer;
/**
 * Checks if given layer is an encoded tile layer.
 *
 * @param layer - The layer to check.
 * @returns True if layer is an encoded tile layer, false if not.
 */
function isEncodedTileLayer(layer) {
    return layer.type === "tilelayer" && layer.encoding !== Encoding_1.Encoding.CSV;
}
exports.isEncodedTileLayer = isEncodedTileLayer;
/**
 * Checks if given layer is an encoded tile layer.
 *
 * @param layer - The layer to check.
 * @returns True if layer is an unencoded tile layer, false if not.
 */
function isUnencodedTileLayer(layer) {
    return layer.type === "tilelayer" && (layer.encoding == null || layer.encoding === Encoding_1.Encoding.CSV);
}
exports.isUnencodedTileLayer = isUnencodedTileLayer;
/**
 * Checks if given layer is an object group.
 *
 * @param layer - The layer to check.
 * @returns True if layer is an object group, false if not.
 */
function isObjectGroup(layer) {
    return layer.type === "objectgroup";
}
exports.isObjectGroup = isObjectGroup;
/**
 * Checks if given layer is an image layer.
 *
 * @param layer - The layer to check.
 * @returns True if layer is an image layer, false if not.
 */
function isImageLayer(layer) {
    return layer.type === "imagelayer";
}
exports.isImageLayer = isImageLayer;
/**
 * Checks if given layer is a group.
 *
 * @param layer - The layer to check.
 * @returns True if layer is a group, false if not.
 */
function isGroup(layer) {
    return layer.type === "group";
}
exports.isGroup = isGroup;
//# sourceMappingURL=AnyLayer.js.map